import { withInstall } from '@jdesign-vue/utils'
import Watermark from './src/watermark.vue'

export const JdWatermark = withInstall(Watermark)
export default JdWatermark

export * from './src/watermark'
